import * as Slider from "@radix-ui/react-slider";
import React, { useEffect } from "react";
import useRange from "./Slider.hook";
import styles from "./Slider.module.scss";

type Props = {
	id: number;
	min: number;
	max: number;
	step: number;
	value?: number[];
	defaultValue?: number[];
	onValueChange?(value: number[]): void;
	onIncrementValue?: (incrementFn: () => void) => void;
	onDecrementValue?: (decrementFn: () => void) => void;
};

export default function Range(props: Props) {
	const {
		id,
		defaultValue,
		min,
		max,
		step,
		onValueChange,
		onIncrementValue,
		onDecrementValue,
	} = props;

	const {
		isShowValue,
		internalValue,
		refs,
		x,
		y,
		strategy,
		handleValueChange,
		incrementValue,
		decrementValue,
	} = useRange({
		id,
		step,
		defaultValue,
		onValueChange,
	});
	useEffect(() => {
		if (onIncrementValue) {
			onIncrementValue(() => incrementValue());
		}
		if (onDecrementValue) {
			onDecrementValue(() => decrementValue());
		}
	}, [onIncrementValue, incrementValue, onDecrementValue, decrementValue]);

	return (
		<Slider.Root
			className={styles.sliderRoot}
			min={min}
			max={max}
			step={step}
			value={internalValue}
			onValueChange={handleValueChange}
		>
			<Slider.Track className={styles.sliderTrack}>
				<Slider.Range className={styles.sliderRange} />
			</Slider.Track>
			<Slider.Thumb
				className={styles.sliderThumb}
				aria-label="Volume"
				ref={refs.setReference}
			/>
			{/* {isShowValue && (
				<span
					ref={refs.setFloating}
					style={{ position: strategy, left: x || 0, top: y || 0 }}
					className={styles.sliderValue}
				>
					{internalValue}
				</span>
			)} */}
		</Slider.Root>
	);
}
